<template>
  <!-- view box 0 0 12 12-->

  <path
    d="M11.25 6.11781C11.25 5.68618 11.2143 5.37121 11.1369 5.04457H6.10717V6.99274H9.05951C9.00001 7.47688 8.67858 8.206 7.96429 8.69593L7.95428 8.76116L9.54459 9.96843L9.65477 9.9792C10.6666 9.06343 11.25 7.71602 11.25 6.11781Z"
    fill="#4285F4"
  />
  <path
    d="M6.10709 11.25C7.55349 11.25 8.76776 10.7833 9.65469 9.97843L7.96421 8.69516C7.51184 9.00431 6.90469 9.22012 6.10709 9.22012C4.69044 9.22012 3.48808 8.30439 3.05947 7.03865L2.99664 7.04388L1.34302 8.29795L1.32139 8.35686C2.20233 10.0717 4.01185 11.25 6.10709 11.25Z"
    fill="#34A853"
  />
  <path
    d="M3.05949 7.03984C2.9464 6.7132 2.88095 6.3632 2.88095 6.00158C2.88095 5.63992 2.9464 5.28996 3.05354 4.96332L3.05054 4.89375L1.37619 3.61953L1.32141 3.64507C0.958335 4.35669 0.75 5.15581 0.75 6.00158C0.75 6.84735 0.958335 7.64643 1.32141 8.35805L3.05949 7.03984Z"
    fill="#FBBC05"
  />
  <path
    d="M6.10709 2.77984C7.11302 2.77984 7.79158 3.20563 8.1785 3.56147L9.69039 2.1149C8.76185 1.26913 7.55349 0.75 6.10709 0.75C4.01185 0.75 2.20233 1.92824 1.32139 3.6431L3.05352 4.96135C3.48808 3.69561 4.69044 2.77984 6.10709 2.77984Z"
    fill="#EB4335"
  />
</template>
